<template>
  <div class="app-container">
    <div class="screeBox">
      <el-input
        class="screenInput"
        v-model="screen.phone"
        placeholder="用户登录手机"
        maxlength="11"
      ></el-input>
      <!-- <el-input
      class="screenInput"
      v-model="screen.nick_name"
      placeholder="昵称"
    ></el-input> -->
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="用户名称"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="chongZhi()"
        >重置</el-button
      >
    </div>
    <el-table
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      max-height="700"  v-loading="listLoading" 
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="用户名称">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="昵称">
        <template slot-scope="scope">
          {{ scope.row.nick_name }}
        </template>
      </el-table-column> -->
      <el-table-column label="头像" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.avatar_url"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageOss + scope.row.avatar_url"
          />
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>

      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="600px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="cztype != 'see' ? rules : rules1"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="ruleForm.name"
            :disabled="cztype != 'add'"
            placeholder="请输入账号名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            maxlength="11"
            v-model="ruleForm.phone"
            :disabled="cztype != 'add'"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="type">
          <el-radio-group
            @input="radioInput"
            v-model="ruleForm.type"
            :disabled="cztype != 'add' || userInfo.type == 2"
          >
            <el-radio :label="1">园区</el-radio>
            <el-radio :label="2">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="头像" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action="ossUpload"
            name="file[]"
            :data="{ type: 'image' }"
            :headers="{ token: token }"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :disabled="cztype == 'see'"
            accept=".jpg,.png,.jpeg"
          >
            <img
              v-if="ruleForm.avatar_url"
              :src="imageOss + ruleForm.avatar_url"
              class="avatar-uploader"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="ruleForm.sex" :disabled="cztype == 'see'">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
            <el-radio :label="3">保密</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-select
            filterable
            v-model="ruleForm.education"
            placeholder="请选择学历"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.value"
              v-for="(item, index) in educationList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否党员" prop="cpc">
          <el-radio-group v-model="ruleForm.cpc" :disabled="cztype == 'see'">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">不是</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="选择角色" v-if="ruleForm.type == 1">
          <el-cascader
            class="w4"
            placeholder="请选择角色"
            :disabled="cztype == 'see'"
            v-model="ruleForm.company_role_data"
            :options="roleList"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              label: 'title',
              value: 'id',
              children: 'nodes',
            }"
            clearable
          ></el-cascader>
        </el-form-item>
        <div v-if="ruleForm.type == 2">
          <el-form-item
            :label="'企业角色' + (index + 1)"
            v-for="(item, index) in domains"
            :key="index"
          >
            <el-select
              filterable
              @change="changeCompany()"
              class="w4"
              v-model="item.company_id"
              placeholder="请选择企业"
              :disabled="cztype == 'see' || userInfo.type == 2"
            >
              <el-option
                :disabled="companyIds.indexOf(item1.id) != -1 ? true : false"
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in companyList"
                :key="index1"
              ></el-option>
            </el-select>
            <el-cascader
              class="w4"
              placeholder="请选择角色"
              :disabled="item.company_id == '' || cztype == 'see'"
              v-model="item.system_role_id"
              :options="roleList"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                label: 'title',
                value: 'id',
                children: 'nodes',
              }"
              clearable
            ></el-cascader>
            <el-button
              style="margin-left: 10px"
              v-if="index != 0"
              type="danger"
              @click.prevent="removeDomain(item)"
              >删除</el-button
            >
          </el-form-item>
        </div>

        <el-form-item v-if="ruleForm.type != 1">
          <el-button type="primary" @click="addDomain">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="用户角色" :visible.sync="userRoleVisible">
      <el-table
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        :data="userRoleData"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="所属园区">
          <template slot-scope="scope">
            <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属企业">
          <template slot-scope="scope">
            <span v-if="scope.row.company">{{ scope.row.company.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">
            <span v-if="scope.row.system_role">{{
              scope.row.system_role.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除角色</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userRoleVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  agoList,
  addAgo,
  infoAgo,
  editAgo,
  delAgo,
  delImage,
  openPark,
  openRole,
  openCompany,
  miniUserRole,
} from "@/api/index";
import { getToken } from "@/utils/auth";
import { userInfo } from "os";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      educationList: [
        {
          title: "小学",
          value: 2,
        },
        {
          title: "初中",
          value: 3,
        },
        {
          title: "高中",
          value: 4,
        },
        {
          title: "专科",
          value: 5,
        },
        {
          title: "本科",
          value: 6,
        },
        {
          title: "研究生",
          value: 7,
        },
        {
          title: "其他",
          value: 1,
        },
      ],
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加用户",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        nick_name: "",
        phone: "",
        name: "",
        is_youke: 1,
      },
      total: 0,
      companyIds: [],
      domains: [{ company_id: "", system_role_id: "" }],
      ruleForm: {
        phone: "",
        name: "",
        park_id: "",
        company_role_data: "",
        status: 1,
        avatar_url: "",
        sex: 3,
        education: ""
      },
      rules1: {},
      rules: {
        name: [{ required: true, message: "请输入账户", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
        ],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        system_role_id: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择账户类型", trigger: "change" },
        ],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      parkList: [],
      roleList: [],
      companyList: [],
      userRoleVisible: false,
      userRoleData: [],
      ScreencompanyList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.ruleForm.park_id = this.userInfo.park_id;
      // this.getCompany("screen", this.screen.park_id);
    } else {
      this.screen.park_id = "";
    }
    if (this.userInfo.type != 2) {
      this.screen.type = "";
    } else {
      this.screen.type = this.userInfo.type;
    }
    // if (this.userInfo.company_id !== 0) {
    //   this.screen.company_id = this.userInfo.company_id;
    // } else {
    //   this.screen.company_id = "";
    // }
    this.fetchData();
    // this.getpark();
    // this.getCompany();
  },
  methods: {
    screenPark(e) {
      this.getCompany("screen", e);
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        nick_name: "",
        phone: "",
        name: "",
        is_youke: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      if (this.userInfo.type == 0) {
        this.screen.type = "";
      } else {
        this.screen.type = this.userInfo.type;
      }
      if (this.userInfo.company_id !== 0) {
        this.screen.company_id = this.userInfo.company_id;
      } else {
        this.screen.company_id = "";
      }
      this.fetchData();
    },
    radioInput(e) {
      this.getCompany();
      this.getrole();
    },
    companyChange(e) {
      this.domains[0].company_id = e;
    },
    parkChange() {
      this.getCompany();
      this.getrole();
      this.domains = [{ company_id: "", system_role_id: "" }];
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    changeCompany() {
      this.companyIds = [];
      this.domains.forEach((item, index) => {
        if (item.company_id) {
          this.companyIds.push(item.company_id);
        }
      });
    },
    // 删除
    removeDomain(item) {
      var index = this.domains.indexOf(item);
      var ids = this.companyIds.indexOf(item.company_id);
      if (index !== -1) {
        this.domains.splice(index, 1);
      }
      if (ids !== -1) {
        this.companyIds.splice(index, 1);
      }
    },
    // 添加园区角色
    addDomain() {
      this.domains.push({ company_id: "", system_role_id: "" });
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        // if (this.ruleForm.avatar_url) {
        //   this.delImg(this.ruleForm.avatar_url);
        // }
        this.ruleForm.avatar_url = res.data.url;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 修改
    editForm(formName) {
      var that = this;
      if (this.ruleForm.type == 2) {
        this.domains.forEach((item) => {
          if (item.company_id && item.system_role_id) {
          } else {
            this.$message({
              message: "企业角色未填写完整！",
              type: "warning",
            });
            return;
          }
        });
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then((_) => {
              if (this.ruleForm.type == 2) {
                that.domains.forEach((item) => {
                  item.system_role_id = item.system_role_id =
                    item.system_role_id[item.system_role_id.length - 1];
                });
                that.ruleForm.company_role_data = JSON.stringify(that.domains);
              } else {
                that.ruleForm.company_role_data =
                  that.ruleForm.company_role_data.toString();
              }
              editAgo(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  // if (this.oldImg != that.ruleForm.icon) {
                  //   that.delImg(this.oldImg);
                  // }
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      // this.oldImg = val.avatar_url
      this.ruleForm.type = val.type;
      this.ruleForm.park_id = val.park_id;
      this.getrole();
      this.domains = [];
      setTimeout(() => {
        this.getInfo(val.id, val.park_id);
      }, 500);
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.domains = [];
      this.ruleForm.type = val.type;
      this.ruleForm.park_id = val.park_id;
      this.getrole();
      setTimeout(() => {
        this.getInfo(val.id, val.park_id);
      }, 500);
      // this.drawer = true;
    },
    async getInfo(id, parkId, type) {
      var that = this;
      var company_role_data = "";
      await infoAgo({ id: id, park_id: parkId }).then((res) => {
        this.ruleForm = {
          type: res.data.type,
          id: res.data.id,
          phone: res.data.phone,
          name: res.data.name,
          park_id: res.data.park_id,
          status: res.data.status,
          avatar_url: res.data.avatar_url,
          sex: res.data.user_extend !== null ? res.data.user_extend.sex : 3,
          education:
            res.data.user_extend !== null ? res.data.user_extend.education : ""
        };
        if (this.ruleForm.type == 2) {
          if (res.data.company_role_data.length > 0) {
            res.data.company_role_data.forEach((item) => {
              that.domains.push({
                company_id: item.company_id != 0 ? item.company_id : "",
                system_role_id: item.system_role_id,
              });
            });
          }

          if (this.domains.length) {
            this.domains.forEach((item, index) => {
              item.system_role_id = that.globalfunc.getParentsById(
                this.roleList,
                item.system_role_id
              );
            });
          } else if (type == "edit") {
            that.domains.push({ company_id: "", system_role_id: "" });
          }
        } else {
          const system_role_id = res.data.company_role_data.length
            ? res.data.company_role_data[0].system_role_id
            : "";

          that.ruleForm.company_role_data = that.globalfunc.getParentsById(
            this.roleList,
            system_role_id
          );
          //  res.data.company_role_data[0].system_role_id.toString()
        }
        this.oldImg = res.data.avatar_url;
        this.changeCompany();
      });
      this.getCompany();
      // this.getrole()
      this.drawer = true;
    },
    // 删除
    openUserRole(id) {
      var that = this;
      miniUserRole({ user_id: id }).then((res) => {
        this.userRoleData = res.data.lists;
        this.userRoleVisible = true;
      });
    },
    handleDelete(val) {
      const data = {
        id: val.user_id,
        role_id: val.system_role_id,
        park_id: val.park_id,
        company_id: val.company_id,
      };
      this.$confirm("确认删除？")
        .then((_) => {
          delAgo(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.openUserRole(val.id);
          });
        })
        .catch((_) => {});
    },
    userRoleChange(val) {
      this.userRoleList = val;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      if (this.ruleForm.type == 2) {
        this.domains.forEach((item) => {
          if (item.company_id && item.system_role_id) {
          } else {
            this.$message({
              message: "企业角色未填写完整！",
              type: "warning",
            });
            return;
          }
        });
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then((_) => {
              if (this.ruleForm.type == 2) {
                that.domains.forEach((item) => {
                  item.system_role_id = item.system_role_id =
                    item.system_role_id[item.system_role_id.length - 1];
                });
                that.ruleForm.company_role_data = JSON.stringify(that.domains);
              } else {
                that.ruleForm.company_role_data =
                  that.ruleForm.company_role_data.toString();
              }
              addAgo(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加用户";
      this.cztype = "add";
      this.ruleForm = {
        phone: "",
        name: "",
        park_id: "",
        company_role_data: "",
        status: 1,
        avatar_url: "",
        sex: 3,
        education: "",
        type: 1,
      };
      this.companyIds = [];
      this.domains = [{ company_id: "", system_role_id: "" }];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.drawer = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      if (this.userInfo.type == 2) {
        this.ruleForm.type = 2;
        this.domains[0].company_id = this.userInfo.company_id;
      }
      this.getrole();
    },
    // 获取企业
    getCompany(type, e) {
      var park_id;
      if (type == "screen") {
        park_id = e;
      } else {
        park_id = this.ruleForm.park_id;
      }
      openCompany({ park_id: park_id, is_page: 2 }).then((response) => {
        if (type == "screen") {
          this.ScreencompanyList = response.data.lists;
        } else {
          this.companyList = response.data.lists;
        }
      });
    },
    // 获取园区
    getpark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取角色
    getrole() {
      const data = {
        is_page: 2,
        is_tree: 1,
        role_type: 2,
      };
      data.park_id = this.ruleForm.park_id;
      // if(this.userInfo.is_super){
      //   data.type = 1
      // }else{
      //   if(this.userInfo.type == 1){
      //     data.type = ''
      //   }
      // }
      data.type = this.ruleForm.type;

      // if (this.userInfo.type !== 0) {
      //   data.type = this.userInfo.type;
      // }
      // if (this.userInfo.park_id !== 0) {
      //   data.park_id = this.userInfo.park_id;
      // }
      openRole(data).then((res) => {
        this.roleList = this.globalfunc.getTreeData(
          res.data.lists,
          this.userInfo.system_role_id
        );
      });
    },
    delAgo() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          delAgo({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      agoList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
</style>
